import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SelectionState } from './selection.reducer';

export const selectSelectionState = createFeatureSelector<SelectionState>('selection');

export const selectSelectedItem = createSelector(selectSelectionState, (state) => state.selectedItem);

export const selectSelectedSection = createSelector(selectSelectionState, (state) => state.selectedSection);

export const selectCallerRole = createSelector(selectSelectionState, (state) => state.callerRole);

export const selectUserAuthenticated = createSelector(selectSelectionState, (state) => state.userAuthenticated);
